import { render, staticRenderFns } from "./footerbar.vue?vue&type=template&id=adc0c524"
import script from "./footerbar.vue?vue&type=script&lang=js"
export * from "./footerbar.vue?vue&type=script&lang=js"
import style0 from "./footerbar.vue?vue&type=style&index=0&id=adc0c524&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports